// Libraries
import { useTranslation } from 'react-i18next';

// MUI
import { Typography } from '@mui/material';

// Core
import { ResourceTextApplication } from '../../../core/resources';

// Common
import { ADialog, ADialogActions, ADialogContent, ADialogTitle } from '../../../common/dialog';

export interface BeginSigningProcessDialogProps {
    onClose: (confirmed: boolean) => void;
}

export default function BeginSigningProcessDialog(props: BeginSigningProcessDialogProps) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaContract']);

    return (
        <ADialog open={true} data-robot-id="confirm-deletion-dialog">
            <ADialogContent size='sm'>
                <Typography className='confirm-dialog-content-typography' variant='body1'>
                    {t('AnelmaContract:1041')}
                </Typography>
            </ADialogContent>

            <ADialogActions
                buttons={{
                    left: [
                        {
                            onClick: () => props.onClose(false),
                            type: 'cancel',
                        },
                    ],
                    right: [
                        {
                            onClick: () => {
                                props.onClose(true);
                            },
                            type: 'ok',
                        },
                    ],
                }}
            />
        </ADialog>
    );
}
